import {Button, Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import React from "react";

export function CustomCardHome({title, subtitle, buttonName, to, children}) {

    return <div className="d-flex flex-column justify-content-between flex-grow-1">
        <div>
            <div className="fs-5 text-start fw-semibold">{title}</div>
            <div className="mb-2 text-sm text-muted-foreground">

                {subtitle}.
            </div>
        </div>
        {children}

        {to && <Button variant="primary" as={Link} to={to} className="mt-auto">{buttonName}</Button>}
    </div>
}

export function CustomCardHomeBottom({icon, title, subtitle, buttonName, to, children}) {

    return <div className="d-flex flex-column justify-content-between flex-grow-1">
        <div>
            <div className="fs-4 text-center fw-semibold mb-3">
                <Link className="d-flex flex-column link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover" to={to}>
                    <i className={`fs-2 bi bi-${icon}`}/>
                    {title}
                </Link>
            </div>
            <div className="mb-2 text-sm text-muted-foreground">
                {subtitle}.
            </div>
        </div>
        {children}
        {/*<Button variant="link" as={Link} className="mt-auto">{buttonName}</Button>*/}
    </div>
}